import srk from "../../Images/actors/srk.jpg";
import salman from "../../Images/actors/salman.jpg";
import abraham from "../../Images/actors/john.jpg";
import deepika from "../../Images/actors/Deepika.jpg";
import ashutosh from "../../Images/actors/Ashutosh.png";

export const data = [
  {
    name: "Shahrukh",
    position: "Pathaan",
    details: `Shah Rukh Khan born 2 November 1965), 
      also known by the initialism SRK, is an Indian actor and film producer who
      works in Hindi films. Referred to in the media as the "Baadshah of Bollywood"
      and "King Khan", he has appeared in more than 80 films, and earned numerous
      accolades, including 14 Filmfare Awards. He has been awarded the Padma Shri
      by the Government of India, as well as the Ordre des Arts et des Lettres and
      Legion of Honour by the Government of France. Khan has a significant following
      in Asia and the Indian diaspora worldwide. `,
    img: srk,
  },
  {
    name: "Deepika",
    position: "rubina",
    details: `Deepika Padukone born 5 January 1986 is an Indian actress who works predominantly 
    in Hindi films. She is one of the highest-paid actresses in India, and her accolades include 
    three Filmfare Awards. She features in listings of the nation's most popular personalities; 
    Time named her one of the 100 most influential people in the world in 2018 and awarded her 
    the TIME100 Impact Award in 2022.Padukone, the daughter of the badminton player Prakash Padukone,
    was born in Copenhagen and raised in Bangalore. As a teenager, she played badminton in national
    level championships but left her career in the sport to become a fashion model. She soon received
    offers for film roles and made her acting debut in 2006 as the title character of the Kannada film
    Aishwarya.`,
    img: deepika,
  },
  {
    name: "Salman",
    position: "Tiger",
    details: `Abdul Rashid Salim Salman Khan (27 December 1965) is an Indian actor,
     film producer, and television personality who works predominantly in Hindi films. In a film career
     spanning over thirty five years, Khan has received numerous awards, including two National Film Awards
     as a film producer, and two Filmfare Awards as an actor.[3] He is cited in the media as one of the most
     commercially successful actors of Indian cinema.[4][5] Forbes has included Khan in listings of the
     highest-paid celebrities in the world, in 2015 and 2018, with him being the highest-ranked Indian in
     the latter year.`,
    img: salman,
  },
  {
    name: "John Abraham",
    position: "jim",
    details: `John Abraham (born 17 December 1972) is an Indian actor and film producer who works primarily
     in Hindi films. He is known for his stoic action hero persona, and has won a National Film Award 
     (as producer) and received several Filmfare Awards nominations. After a successful modelling career, 
     Abraham made his acting debut with the erotic thriller film Jism (2003), a sleeper hit.[2]He gained
     success with the action film Dhoom (2004) and expanded to comedic roles in Garam Masala (2005),
     Taxi No. 9211 (2006), Dostana (2008). He also starred in the critically acclaimed dramas Water
     (2005), Kabul Express (2006) and New York (2009). In the subsequent decade, Abraham's career
     fluctuated commercially.`,
    img: abraham,
  },
  {
    name: "Ashutosh",
    position: "colonil sunil",
    details: `Ashutosh Ramnarayan Neekhra (born 10 November 1967), known professionally as Ashutosh Rana, 
    is an Indian actor, producer, author and television personality. He has worked in Marathi, Telugu, 
    Kannada, Tamil, and Hindi films. He has also worked in Indian television shows. He has also won two 
    Filmfare Awards for Dushman and Sangharsh. He won these awards in the category Filmfare Awards in a 
    negative role. He is known for his portrayal of negative roles.Besides being an actor, he is also an author.
    Some of the books written by him are 'Maun Muskaan Ki Maar' and 'Ramrajya'.`,
    img: ashutosh,
  },
];
